module.exports = __webpack_public_path__ + "media/web_compressed.2530230e.mp4";